import EN_US from '../translations/en-us'
import EN_GB from '../translations/en-gb'
import EN_IN from '../translations/en-in'
import EN_AU from '../translations/en-au'
import FR from '../translations/fr'
import DE from '../translations/de'
import ES from '../translations/es'
import NL from '../translations/nl'
import IT from '../translations/it'
import NO from '../translations/no'
import RU from '../translations/ru'
import PT from '../translations/pt'
import PL from '../translations/pl'
import KO from '../translations/ko'
import JA from '../translations/ja'
import ZH from '../translations/zh'
import TR from '../translations/tr'

export default {
    'en-us': EN_US,
    'en-au': EN_AU,
    'en-gb': EN_GB,
    'en-in': EN_IN,
    'fr': FR,
    'de': DE,
    'es': ES,
    'ja': JA,
    'ko': KO,
    'pt': PT,
    'zh': ZH,
    'it': IT,
    'nl': NL,
    'no': NO,
    'pl': PL,
    'ru': RU,
    'tr': TR
}